"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.openMethod = exports.routerLink = exports.targetPageData = void 0;
const fdr_lib_router_open_method_1 = require("@hotelplan/fdr.lib.router.open-method");
const fdr_lib_router_target_page_1 = require("@hotelplan/fdr.lib.router.target-page");
const supergraph_api_1 = require("@hotelplan/supergraph-api");
function targetPageData(link, hiddenQueryParams = {}) {
    if (!link)
        return null;
    if (link.__typename === 'FdrLink' && link.type === supergraph_api_1.FdrLinkType.Internal)
        return (0, fdr_lib_router_target_page_1.getFdrTargetPageData)(link.url, hiddenQueryParams);
    return null;
}
exports.targetPageData = targetPageData;
function routerLink(link) {
    if (!link)
        return null;
    if (link.__typename === 'FdrLink')
        return (0, fdr_lib_router_target_page_1.getFdrRouterLink)(link);
    return null;
}
exports.routerLink = routerLink;
function openMethod(link) {
    if (!link)
        return null;
    if (link.__typename === 'FdrLink')
        return (0, fdr_lib_router_open_method_1.getFdrOpenMethod)(link.openMethod);
    return null;
}
exports.openMethod = openMethod;
//# sourceMappingURL=index.js.map